/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';

import Localizable from 'lib/intl/localizable';
import { Form, Field } from 'lib/form/form';
import withDialog from 'lib/alerts/with-dialog';
import Styled from 'styled';
import { ValueFieldData } from 'lib/form/value-field-data';

import { RuleStore } from 'four-nets/forum/forum';
import SelectView from 'four-nets/ui/form/select-view';
import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';

import FormView from './form/form-view';
import defaultStyles from './delete-comment-view.scss';

export class DeleteCommentViewModel {
    comment: Comment;

    constructor(options: { comment: Comment }) {
        const { comment } = options;
        this.comment = comment;
    }

    handleSubmit = ({
        data,
    }: {
        data: {
            rule: ?number,
            comment: String,
        },
    }) => {
        const { rule: ruleId, comment } = data;
        return this.comment.delete(ruleId, comment);
    };

    @action setupForm = () => {
        const form = new Form({
            field: {
                rule: new Field({
                    data: new ValueFieldData({
                        value: -1,
                    }),
                }),
                comment: new Field({
                    data: new ValueFieldData({
                        value: '',
                    }),
                }),
            },
            handleSubmit: this.handleSubmit,
        });
        return form;
    };
}

@Localizable()
@withStackViewForm({
    hideAction: true,
    title: <FormattedMessage id='FORUM_COMMENT_DELETE_CONFIRMATION_TEXT' />,
    acceptButtonType: 'warn',
})
@withDialog
@Styled(defaultStyles)
@observer
class DeleteCommentView extends React.Component {
    @observable rules = [];

    static contextTypes = {
        api: PropTypes.object,
    };

    UNSAFE_componentWillMount() {
        const ruleStore = new RuleStore({
            api: this.context.api,
        });
        // FIXME missing error handling
        ruleStore.loadAll().then(rules => {
            this.rules = rules;
        });
    }

    render() {
        const {
            submit,
            form,
            intl: { _ },
            styles,
        } = this.props;
        const { valid, dirty } = form;

        return (
            <FormView form={form} submitOnEnter={false} submit={submit}>
                <FieldWithLabelView
                    field={
                        <SelectView
                            onChange={form.field.get('rule').data.onChange}
                            value={form.field.get('rule').data.value}
                            field={form.field.get('rule')}
                        >
                            <option value={-1}>---</option>
                            {this.rules.map(rule => {
                                return (
                                    <option value={rule.id} key={rule.id}>
                                        {rule.label}
                                    </option>
                                );
                            })}
                        </SelectView>
                    }
                    label={<FormattedMessage id='FORM_FIELD_LABEL_RULE' />}
                />
                <div className={styles.field}>
                    <FieldWithLabelView
                        field={<TextAreaView field={form.field.get('comment')} type='text' emojify={false} />}
                        label={<FormattedMessage id='FORM_FIELD_LABEL_BODY' />}
                    />
                </div>
                <div className={styles.field}>
                    <SubmitButtonView disabled={!(valid && dirty)} onClick={submit}>
                        <span className={styles.label}>{<FormattedMessage id='BUTTON_LABEL_SAVE' />}</span>
                    </SubmitButtonView>
                </div>
            </FormView>
        );
    }
}

export default DeleteCommentView;
